.lkuti40 {
  width: 100%;
  height: 60px;
  margin: 16px 0;
}
.lkuti41 {
  width: 100%;
  position: relative;
  height: 20px;
}
.lkuti42 {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 1px;
}
.lkuti42[data-state="filled"] {
  background: var(--_1qu8za23u);
  left: calc(76px/2);
  right: 50%;
}
.lkuti42[data-state="empty"] {
  background: var(--_1qu8za23p);
  left: 50%;
  right: calc(76px/2);
}
.lkuti43 {
  font-size: 12px;
  height: 20px;
  width: 20px;
  border-radius: 9999px;
  position: absolute;
  border: 1px solid var(--_1qu8za23q);
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.lkuti43[data-state="filled"] {
  background: var(--_1qu8za23q);
  color: var(--_1qu8za23x);
  left: calc(76px/2);
  transform: translateX(-50%);
}
.lkuti43[data-state="current"] {
  background: var(--_1qu8za2b);
  color: var(--_1qu8za23q);
  right: 50%;
  transform: translateX(50%);
}
.lkuti43[data-state="empty"] {
  background: var(--_1qu8za2b);
  border: 1px solid var(--_1qu8za23p);
  right: calc(76px/2);
  transform: translateX(50%);
}
.lkuti44 {
  font-weight: 500;
  font-size: 12px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  width: 76px;
  color: var(--_1qu8za24);
}
.lkuti45 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  text-align: center;
  margin-top: 2px;
}